module.exports = "\n<div class=\"comp-page-bottom-static-container\">\n  <partners-slider v-on:boundingUpdated=\"onPartnersSliderBoundingUpdated\"></partners-slider>\n  <cookie-accept></cookie-accept>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/page_bottom_static_container/index.pug
// module id = 650
// module chunks = 4